import React from 'react';
import { CheckCircle2, AlertCircle, X } from 'lucide-react';

// Compact outcome list for a "apply barcodes" run — one line per colour
// variation, with the reason whenever a barcode didn't reach Square.

export default function BarcodePushResult({ result, onClose }) {
  if (!result) return null;

  return (
    <div className="mt-4 border border-white/10 bg-[#111115]">
      <div className="flex items-center gap-3 px-4 py-3 border-b border-white/5">
        <p className="text-white text-sm font-bold">
          {result.updated} barcode{result.updated !== 1 ? 's' : ''} applied
          {result.failed > 0 && <span className="text-red-400 font-normal"> · {result.failed} failed</span>}
        </p>
        <button onClick={onClose} className="ml-auto text-white/30 hover:text-white p-1 shrink-0" title="Dismiss">
          <X className="w-4 h-4" />
        </button>
      </div>

      <div className="max-h-72 overflow-y-auto divide-y divide-white/5">
        {result.results.map((r) => {
          const ok = r.status === 'updated';
          const Icon = ok ? CheckCircle2 : AlertCircle;
          return (
            <div key={r.colour} className="flex items-start gap-3 px-4 py-2.5">
              <Icon className={`w-4 h-4 mt-0.5 shrink-0 ${ok ? 'text-green-400' : 'text-red-400'}`} />
              <div className="min-w-0">
                <p className="text-white text-xs font-bold truncate">
                  {r.colour} <span className="text-white/40 font-mono font-normal">{r.gtin}</span>
                </p>
                <p className="text-white/40 text-[11px]">
                  {ok ? 'Set on the record and sent to Square' : r.reason}
                </p>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}